import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { notificationAPI } from "../../helpers/api/notification";

export const getNotifications = createAsyncThunk(
  "notifications/getNotifications", 
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.getAll();
      return response;
    } catch (error) {
      toast.error("Failed to fetch notifications", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to fetch notifications");
    }
  }
);

export const getNotificationById = createAsyncThunk(
  "notifications/getNotification", 
  async (ID, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.getById(ID);
      return response;
    } catch (error) {
      toast.error("Failed to fetch notification", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to fetch notification");
    }
  }
);

export const setNotificationAsRead = createAsyncThunk(
  "notifications/setNotificationAsRead",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.mark_as_read(ID);
      return response;
    } catch (error) {
      toast.error("Failed to mark notification as read", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to mark notification as read");
    }
  }
);

export const rejectInvoice = createAsyncThunk(
  "notifications/rejectInvoice",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.reject_invoice(ID);
      return response;
    } catch (error) {
      toast.error("Failed to reject invoice", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to reject invoice");
    }
  }
);

export const approveInvoice = createAsyncThunk(
  "notifications/approveInvoice",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.approve_invoice(ID);
      return response;
    } catch (error) {
      toast.error("Failed to approve invoice", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to approve invoice");
    }
  }
);

export const markAllAsRead = createAsyncThunk(
  "notifications/markAllAsRead",
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationAPI.markAllAsRead();
      return response;
    } catch (error) {
      toast.error("Failed to mark all notifications as read", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to mark all as read");
    }
  }
);